import {
  KeyboardArrowDown,
  Edit,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "../../assets/img/no-record.png";
import DeletePrompt from "../Common/DeletePrompt";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as message from "../../config/CommonMessages";
import {
  addBillingItems,
  getAllBillingItems,
  editBillingItems,
} from "../../actions/BillingActions";
import * as code from "../../config/Constants";
import { getUserRolesActionNew } from "../../actions/UserActions";
import {
  AddAiVersion,
  GetAiVersion,
  updateAiVersion,
} from "../../actions/UserActions";

class OpneaiVersion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Ai Versions",
      showAddModal: false,
      showEditPrompt: false,
      versionItemCode: "",
      versionItemDesc: "",
      Isactive: false,
      editIsactive: false,
      Versions: [],
      editId: "",
      itemCodeduplicat: false,
      roles: [],
    };
  }
  columns = [
    {
      name: "Verion Item Desc",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "Verion Item Code",
      selector: "shortcode",
      sortable: true,
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "Status",
      selector: "status",
      //sortable: true,
      ignoreRowClick: true,
      width: "10%",
    },
    {
      name: "CreatedBy",
      selector: "createdby",
      sortable: true,
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "ModifiedBy",
      selector: "modifiedby",
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];

  openAddModal() {
    this.setState({
      showAddModal: true,
    });
  }

  componentWillMount() {
    this.getallVersions();
    // this.getalluserroles();
  }

  getalluserroles() {
    this.setState({
      showLoader: true,
    });
    this.props.getUserRolesActionNew().then((result) => {
      this.setState({
        roles: result,
        showLoader: false,
      });
      // console.log("result119", result);
    });
  }

  getallVersions() {
    this.setState({
      showLoader: true,
    });
    this.props.GetAiVersion().then((result) => {
      this.setState({
        Versions:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data
            : [],
        showLoader: false,
      });
    });
  }
  openEditPrompt(billingItem) {
    // console.log("billingItem", billingItem);
    this.setState({
      showEditPrompt: true,
      editId: billingItem._id,
      versionItemCode: billingItem.versionItemCode,
      versionItemDesc: billingItem.versionItemDesc,
      editIsactive: billingItem.Isactive,
    });
  }
  addVersions(values) {
    // console.log("values-134", values);
    this.props
      .AddAiVersion(values)
      .then((res) => {
        if (res.status === code.OK) {
          this.setState({
            showAddModal: false,
            versionItemCode: "",
            versionItemDesc: "",
            Isactive: false,
            itemCodeduplicat: false,
          });
          this.getallVersions();
        } else {
          if (res.data === "duplicate") {
            this.setState({
              itemCodeduplicat: true,
            });
          }
        }
      })
      .catch((err) => {});
  }
  updateAiVersion(values) {
    // console.log("values-163", values);
    this.props
      .updateAiVersion(values)
      .then((res) => {
        this.setState({
          showEditPrompt: false,
          versionItemCode: "",
          versionItemDesc: "",
          Isactive: false,
          editId: "",
        });
        this.getallVersions();
      })
      .catch((err) => {});
  }

  render() {
    let rows = [];
    for (var i = 0, len = this.state.Versions.length; i < len; i++) {
      let Versions = this.state.Versions[i];
      let data = {
        name: Versions.versionItemDesc,
        shortcode: Versions.versionItemCode,

        status: Versions.Isactive ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),

        createdby: Versions.createdby ? Versions.createdby : "",
        modifiedby: Versions.modifiedby ? Versions.modifiedby : "",

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.openEditPrompt(Versions);
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col align="right">
            <Button
              onClick={() => {
                this.openAddModal();
              }}
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Add
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.contingencyID}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.deleteContingency}
            />

            <Modal
              show={this.state.showAddModal}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Add New Version
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <Formik
                  validateOnBlur={true}
                  initialValues={this.state}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    versionItemCode: Yup.string()
                      .trim()
                      .required(message.THIS_FEILD_IS_REQUIRED)
                      .max(20, message.MAX_BILLING_ITEM),
                    versionItemDesc: Yup.string()
                      .trim()
                      .required(message.THIS_FEILD_IS_REQUIRED),
                  })}
                  onSubmit={(values) => {
                    let data = {
                      versionItemCode: values.versionItemCode
                        .toLowerCase()
                        .trim()
                        .split(" ")
                        .join(""),
                      versionItemDesc: values.versionItemDesc.trim(),
                      Isactive: values.Isactive,
                      createdby: localStorage.getItem("userName"),
                    };
                    this.addVersions(data);
                  }}
                >
                  <Form
                    className="form-sm form-admin"
                    style={{ marginBottom: 15 }}
                  >
                    <div className="form-group">
                      <label>
                        Ai Version Code
                        <span className="text-danger"> *</span>
                      </label>

                      <Field
                        type="text"
                        className="form-control"
                        name="versionItemCode"
                        onChange={(e) => {
                          this.setState({ versionItemCode: e.target.value });
                        }}
                      />

                      <ErrorMessage
                        name="versionItemCode"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      {this.state.itemCodeduplicat ? (
                        <div className="text-danger">
                          Billing item duplicate
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Ai Version Description
                        <span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="versionItemDesc"
                        onChange={(e) => {
                          this.setState({ versionItemDesc: e.target.value });
                        }}
                      />
                      <ErrorMessage
                        name="versionItemDesc"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>

                    <div className="form-group">
                      <Field
                        type="checkbox"
                        name="Isactive"
                        value={this.state.Isactive}
                        onChange={(e) => {
                          this.setState({
                            Isactive: e.target.checked,
                          });
                        }}
                        style={{ marginRight: 5 }}
                      />
                      <label
                        htmlFor="setIsParticipant"
                        className="form-check-label"
                        style={{ paddingRight: 26 }}
                      >
                        Is Active?
                      </label>
                      <ErrorMessage
                        name="Isactive"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Button
                      variant="primary"
                      className="btn-blue w-140"
                      type="submit"
                      style={{ marginRight: 10 }}
                    >
                      Add
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-140"
                      onClick={() => {
                        this.setState({
                          showAddModal: false,
                          versionItemCode: "",
                          versionItemDesc: "",
                          Isactive: false,
                          itemCodeduplicat: false,
                        });
                      }}
                    >
                      Cancel
                    </Button>
                  </Form>
                </Formik>
              </Modal.Body>
            </Modal>

            {/* Edit Data Modal */}
            <Modal
              show={this.state.showEditPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Edit Ai Version
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <Formik
                  validateOnBlur={true}
                  initialValues={this.state}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    versionItemCode: Yup.string()
                      .trim()
                      .required(message.THIS_FEILD_IS_REQUIRED),
                    versionItemDesc: Yup.string()
                      .trim()
                      .required(message.THIS_FEILD_IS_REQUIRED),
                  })}
                  onSubmit={(values, errors) => {
                    let data = {
                      versionItemCode: values.versionItemCode
                        .toLowerCase()
                        .trim(),
                      versionItemDesc: values.versionItemDesc.trim(),
                      Isactive: values.editIsactive,
                      modifiedby: localStorage.getItem("userName"),
                      editId: this.state.editId,
                    };
                    this.updateAiVersion(data);
                  }}
                >
                  <Form
                    className="form-sm form-admin"
                    style={{ marginBottom: 15 }}
                  >
                    <div className="form-group">
                      <label>
                        Ai Version Code
                        <span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="versionItemCode"
                        readOnly
                      />
                      <ErrorMessage
                        name="versionItemCode"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        Ai Version Description
                        <span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="versionItemDesc"
                        onChange={(e) => {
                          this.setState({ versionItemDesc: e.target.value });
                        }}
                      />
                      <ErrorMessage
                        name="versionItemDesc"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>

                    <div className="form-group">
                      {this.state.editIsactive}
                      <Field
                        type="checkbox"
                        name="Isactive"
                        checked={this.state.editIsactive}
                        onChange={(e) => {
                          this.setState({
                            editIsactive: e.target.checked,
                          });
                        }}
                        style={{ marginRight: 5 }}
                      />
                      <label
                        htmlFor="setIsParticipant"
                        className="form-check-label"
                        style={{ paddingRight: 26 }}
                      >
                        Is Active?
                      </label>
                      <ErrorMessage
                        name="Isactive"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Button
                      variant="primary"
                      className="btn-blue w-140"
                      type="submit"
                      style={{ marginRight: 10 }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-140"
                      onClick={() => {
                        this.setState({
                          versionItemCode: "",
                          versionItemDesc: "",
                          Isactive: false,
                          showEditPrompt: false,
                        });
                      }}
                    >
                      Cancel
                    </Button>
                  </Form>
                </Formik>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    addBillingItems,
    getAllBillingItems,
    editBillingItems,
    getUserRolesActionNew,
    AddAiVersion,
    GetAiVersion,
    updateAiVersion,
  }
)(OpneaiVersion);
